<template>
  <div id="app">
    <router-view/>
  </div>
</template>
<script>
  export default {
      components:{
      },
      mounted () {
//          //在页面加载时读取sessionStorage里的状态信息
//          if (localStorage.getItem("state") ) {
//              this.$store.replaceState(Object.assign({}, this.$store.state,JSON.parse(localStorage.getItem("state"))))
//          }
//
//          //在页面刷新时将vuex里的信息保存到sessionStorage里
//          window.addEventListener("beforeunload",()=>{
//              localStorage.setItem("state",JSON.stringify(this.$store.state));
//          })
      }
  }
</script>

<style lang="scss">
  html{
    height: 100%;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    line-height: 1.15;
    -ms-text-size-adjust: 100%;
    -webkit-text-size-adjust: 100%;
  }
  body{
    height: 100%;
    padding: 0;
    margin: 0;
    -webkit-font-smoothing: antialiased;
    text-rendering: optimizeLegibility;
    font-family: Helvetica Neue, Helvetica, PingFang SC, Hiragino Sans GB, Microsoft YaHei, Arial, sans-serif;
  }
  #app{
    height: 100%;
  }
  *, *:before, *:after {
    -webkit-box-sizing: inherit;
    box-sizing: inherit;
  }
</style>
